/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ad-host{display:flex;align-items:center;justify-content:center;width:100%;max-width:100%;overflow:hidden;min-height:90px;max-height:600px}ad-host:empty{display:none}ad-host.margin-bottom{margin-bottom:15px}ad-host.margin-top{margin-top:15px}ad-host>:not(img){width:100%;height:100%;max-width:1200px;min-height:90px;max-height:600px}@media only screen and (max-width:599.99px){ad-host>:not(img){max-width:370px}}"];
export { styles as styles };
